import React, { useState, useEffect } from "react";

import { BackgroundV1 } from "./loginBackground";

import cx from "classnames";
import styles from "./anonymousPageView.module.scss";

const AnonymousPageView = (props) => {
  const [state, setState] = useState({
    loading: true,
    background: {},
  });

  const selectBackground = () => {
    const pictureArray = [BackgroundV1];
    const randomIndex = Math.floor(Math.random() * pictureArray.length);
    const background = pictureArray[randomIndex];
  
    setState({
      background: background,
    });
  };

  useEffect(() => {
    selectBackground();
  }, []);

  if (state.loading) {
    return null;
  }

  return (
    <div className={cx(styles.content, props.className)}>
      {state.background && React.createElement(state.background)}
      <div
        className={cx(
          styles.equalHeight,
          styles.innerContent,
          styles.verticalCenter
        )}
      ></div>
      {props.children}
    </div>
  );
};



export default AnonymousPageView;
